export const paymentMethodProduitsIncompatiblesProps = () => ({
  produitsIncompatibles: {
    type: Array,
    required: false,
    default: []
  },
  modePaiement: {
    type: String,
    required: false,
    default: null
  }
})

export const usePaymentMethodProduitsIncompatibles = (props) => {

  const produitsIncompatiblesUniques = computed(() => {
    return props.produitsIncompatibles.filter((product, index, array) => array.findIndex(product2 => (product2.attributes.produit.data.id === product.attributes.produit.data.id)) === index)
  })

  return { produitsIncompatiblesUniques }
}